import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CurtainsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"curtains"}/>
}
